import { commitMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

const mutation = graphql`
    mutation rescheduleEventMutation($input: rescheduleHyeventInput!){
        rescheduleHyevent(input:$input) {
          clientMutationId
          hyevent{
            id
          }
        }
    }
`;

function commit(environment, input) {
  return new Promise((res, rej) => {
    commitMutation(environment, {
      mutation,
      variables: { input },
      onCompleted: res,
      onError: rej
    })
  });
}

export default commit;